import { PageTitle } from "../../../_metronic/layout/core";

function UnidentifiedUserLocatario() {
    return (
        <>
            <PageTitle>Usuario no identificado</PageTitle>

            <div className="d-flex flex-column flex-column-fluid text-center p-10 py-lg-15">
                <div className="pt-lg-10 mb-10">
                    <h1 className="fw-bolder fs-2qx text-gray-800 mb-10">Usuario no identificado</h1>
                    <div className="fw-bold fs-3 text-muted mb-15">Su usuario no tiene un identificador.<br></br> Si cree que se trata de un error, póngase <br></br> en contacto con el administrador.</div>
                </div>
            </div>
        </>
    )
}
export { UnidentifiedUserLocatario }